import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M10 17l5-5-5-5v10z"
}), 'ArrowRight');